import { render, staticRenderFns } from "./crear-procesos.vue?vue&type=template&id=0c53b021"
import script from "./crear-procesos.vue?vue&type=script&lang=js"
export * from "./crear-procesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports